import { environment } from "src/environments/environment";
import { ActionService } from "./action.service";
import { Injectable } from "@angular/core";

@Injectable()
export class HrefService {
  constructor(private service: ActionService) {}

  getUrl(path: string, requireAuth?: boolean, post?: string) {
    let auth = "";
    if (requireAuth) auth = "/" + this.service.client.Token;
    if (post) auth += "/" + post;

    if (environment.WebSocket)
      return (
        environment.WebSocket.replace("wss://", "https://")
          .replace("ws://", "http://")
          .replace("/wss", "/" + path) + auth
      );

    return (
      document.location.protocol +
      "//" +
      document.location.hostname +
      "/" +
      path +
      auth
    );
  }
  getImageUrl(
    path: string,
    requireAuth?: boolean,
    post?: string,
    after?: string
  ) {
    let auth = "";
    if (post) auth += "/" + post;
    if (requireAuth) auth += "/" + this.service.client.Token;
    if (after) auth += after;

    if (environment.WebSocket)
      return (
        environment.WebSocket.replace("wss://", "https://")
          .replace("ws://", "http://")
          .replace("/wss", "/" + path) + auth
      );

    return (
      document.location.protocol +
      "//" +
      document.location.hostname +
      "/" +
      path +
      auth
    );
  }
}
